import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

const VerMediosdePago = ({data, SeleccionarmediodePago}) => {

	return(
		<div>
			<MDBTable hover>
		      <MDBTableHead>
		        <tr>
		          <th>Activo</th>
		          <th>Nombre</th>
		          <th>Estado</th>
				  <th>Tarifa</th>
		          <th></th>
		        </tr>
		      </MDBTableHead>
		      <MDBTableBody>

		      	{data.map((item, index) => {
		      		return(
				        <tr key={index}>
				          <td>{item.activo === 'true' ? 'Si' : 'No'}</td>
				          <td>{item.nombre}</td>
				          <td>{item.estado}</td>
						  <td>{item.tarifa}</td>
				          <td className="tabla_funciones">
				          	<center>	
				          	<button 
								onClick={SeleccionarmediodePago(item, 'editar')}
								className="btn boton_estandar_blanco"							
								><FontAwesomeIcon icon={faEdit} size="lg"/>
							</button>

							<button 
								onClick={SeleccionarmediodePago(item, 'eliminar')}
								className="btn boton_estandar_blanco"							
								><FontAwesomeIcon icon={faTrashAlt} size="lg"/>
							</button>
							</center>

				          </td>
				        </tr>
			        )

		        })}

		      </MDBTableBody>
		    </MDBTable>
		</div>
	)
}

export default VerMediosdePago